import Info from './info.icon.svg';
import css from './size.module.scss';
import { formatSize } from './utils';

interface Props {
    value: string;
}
export function Size({ value }: Props) {
    const max = 14 * 1024;
    const bytes = new TextEncoder().encode(value).length;
    const ratio = Math.min(1, Math.max(0, bytes / max));

    return (
        <div className={css.stat}>
            <p className={css.label}>CacheKey Size</p>
            <div className={css.row}>
                <p className={css.value}>{formatSize(bytes)}</p>
                <div className={css.progress}>
                    <span className={css.fill} style={{ width: `${ratio * 100}%` }} />
                </div>
                <span className={css.limit}>
                    <span className={css.slash}>/</span>
                    {formatSize(max)}
                </span>
                <span className={css.chip}>
                    {bytes === 0 ? 0 : bytes >= max ? 100 : Math.max(1, Math.min(99, Math.round(ratio * 100)))}%
                </span>
            </div>

            <p className={css.note}>
                <span>{formatSize(Math.max(0, max - bytes))} remaining</span>
                <span className={css.info}>
                    <Info />
                </span>
            </p>
        </div>
    );
}
